import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import loadTranslations from "./translationLoader";
import getProjectConfig from "../configs/projectConfigs";
import intervalPlural from 'i18next-intervalplural-postprocessor';

const supportedLanguages = ["en", "ar"];
const namespaces = [
  "common", "login", "forgotPassword", "checkEmail", "logout", "sidebar", "notifications",
  "cardsSections", "statisticsSection", "rides", "addNewRide", "viewRide", "cancelRide", "cancelSharedRide",
  "endSharedRide", "endRide", "assignRide",
  "passengerDetails", "rideDetails", "rideRating", "rideTimeline", "vehicleDetails",
  "table", "status", "passengers", "passengerInfo", "ridesHistory", "review", "creditCards", "savedAddresses", "wallet",
  "drivers", "viewDriver", "contactUs", "chat", "topbar", "sharedZones", "dispatch", "cards", "track", "settings", "profile",
  "driversReports", "ridesReports", "helpCenter", "ticket", "messages", "addNewCustomer", "unblockDriver", "assignDriver",
  "coupons", "termsAndConditions"
];
const initializeI18n = async () => {
  const resources = {};
  for (const lang of supportedLanguages) {
    resources[lang] = await loadTranslations(lang);
  }
  const projectConfig = getProjectConfig();

  const preferredLanguage = localStorage.getItem('userLanguagePreference');
  const language = preferredLanguage || projectConfig?.language || "en";

  i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: "en",
    ns: namespaces,
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === "development",
    react: {
      useSuspense: true,
    },
  });
};

initializeI18n();

export default i18n;
